<template>
  <div id="ecommerce">
    <template v-if="isSelectedBot">
      <v-layout wrap>
        <v-flex sm1 shrink class="text-xs-right">
          <v-btn v-if="!showAllMenu" color="primary" icon outline @click="setShowAllMenu"
            ><i class="fa fa-th" aria-hidden="true"></i
          ></v-btn>
        </v-flex>
        <v-flex sm11>
          <v-tabs
            v-if="!showAllMenu"
            v-model="currentView"
            color="white"
            :slider-color="$vuetify.theme.primary"
            show-arrows
          >
            <v-tab
              v-if="
                $store.state.centralPage.includes(selectedBot.pageid) &&
                  $store.state.privilege.role === 'admin' &&
                  $store.state.loginChannel === 'account'
              "
              href="#ecommerce-order-summary"
              ripple
              >{{ $t('Order Summary') }}</v-tab
            >
            <template v-else>
              <v-tab href="#ShopProfilePage" ripple>{{ $t('Shop Profile') }}</v-tab>
              <v-tab href="#Products" ripple>{{ $t('product_discount') }}</v-tab>
              <v-tab href="#mainPayment" ripple>{{ $t('Payments') }}</v-tab>
              <v-tab href="#ShippingMethod" ripple>{{ $t('Shipping Method') }}</v-tab>
              <v-tab href="#SalePage" ripple>{{ $t('Sale Page') }} </v-tab>
              <v-premium-lock style="margin-top: 5px; margin-left: -6px;" :inline="true">
              </v-premium-lock>
              <v-tab href="#CartSummary" ripple>{{ $t('Cart Summary') }}</v-tab>
              <v-premium-lock style="margin-top: 5px; margin-left: -6px;" :inline="true">
              </v-premium-lock>
              <v-tab href="#ecommerce-order-summary" ripple>{{ $t('Order Summary') }}</v-tab>
              <template v-if="selectedBot.pageid == '853384435005817'">
                <v-tab href="#BearhouseOrder" ripple>{{ $t('Order Summary') }} 2</v-tab>
              </template>
              <v-tab
                ripple
                href="#AstonAds"
                v-if="$aston.astonpages.includes(selectedBot.pageid)"
                >{{ $t('Aston') }}</v-tab
              >
              <v-tab
                ripple
                href="#AstonAuction"
                v-if="$aston.astonpages.includes(selectedBot.pageid)"
                >{{ $t('Auction') }}</v-tab
              >
              <v-tab
                ripple
                href="#AstonTagSummary"
                v-if="$aston.astonpages.includes(selectedBot.pageid)"
                >{{ $t('Ads Report') }}</v-tab
              >
              <v-tab
                href="#Influencers"
                ripple
                v-if="['103876431747147', '176922345693076'].includes(selectedBot.pageid)"
                >{{ $t('Influencers') }}</v-tab
              >
              <v-tab
                href="#Delivery"
                ripple
                v-if="$store.state.foodDelivery.includes(selectedBot.pageid)"
                >{{ $t('Google Map') }}</v-tab
              >
              <v-tab
                href="#orderdaily"
                ripple
                v-if="['145969602635827', '100164365566364'].includes(selectedBot.pageid)"
                >{{ $t('ยอดการสั้งซื้อตามวัน') }}</v-tab
              >
            </template>
          </v-tabs>
        </v-flex>
      </v-layout>
      <v-container v-if="showAllMenu">
        <h1 class="mb-3 mt-1">{{ $t('Shop/Salepage') }}</h1>
        <v-layout row wrap>
          <template v-for="(menu, i) in menuTab">
            <template v-if="menu.page.length === 0 || menu.page.includes(selectedBot.pageid)">
              <v-flex
                xs4
                sm3
                md2
                lg2
                style="padding: 2%"
                :key="i"
                v-if="menu.tab !== 'ProductAnalytics' || showProductAnalytic"
              >
                <v-hover
                  style="cursor: pointer"
                  v-if="menu.isPremiumLock.includes($store.getters.getPackage)"
                >
                  <v-card
                    slot-scope="{ hover }"
                    @click="setTabMenu(menu.tab)"
                    :class="`elevation-${hover ? 12 : 2}`"
                    style="height: 100%"
                    class="text-xs-center"
                  >
                    <v-img
                      aspect-ratio="1"
                      :src="`/static/img/assets/shop-menu/${menu.image}.jpg`"
                      class="white--text align-end"
                    >
                    </v-img>

                    <v-card-actions class="primary--text" style="justify-content: center;">
                      <span>{{ menu.name }}</span>
                    </v-card-actions>
                  </v-card>
                </v-hover>
                <div v-else>
                  <v-card
                    :class="`elevation-${hover ? 12 : 2}`"
                    style="height: 100%"
                    class="text-xs-center"
                  >
                    <v-img
                      style="opacity: 0.5;"
                      aspect-ratio="1"
                      :src="`/static/img/assets/shop-menu/${menu.image}.jpg`"
                      class="white--text align-end"
                    >
                    </v-img>
                    <v-btn
                      v-if="!$vuetify.breakpoint.xs"
                      @click="setTabMenu(menu.tab)"
                      color="primary"
                      style="margin: auto; position: absolute; top: 10px; left: 15px;"
                      >ดูตัวอย่าง
                    </v-btn>
                    <v-premium-lock></v-premium-lock>
                    <v-card-actions
                      class="primary--text"
                      style="justify-content: center; opacity: 0.5"
                    >
                      <span>{{ menu.name }}</span>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-flex>
            </template>
          </template>
        </v-layout>
      </v-container>
      <template v-if="!showAllMenu">
        <template
          v-if="
            (currentView == 'Products' && !$store.state.subcategory.includes(selectedBot.pageid)) || currentView == 'Wholesale' || currentView == 'Promotion'
          "
        >
          <products-tab></products-tab>
        </template>
        <template
          v-else-if="currentView == 'Products' && $store.state.subcategory.includes(selectedBot.pageid)"
        >
          <component :is="'KanomProducts'"></component>
        </template>
        <template v-else>
          <component :is="currentView"></component>
        </template>
      </template>
    </template>
    <template v-else>
      <template-empty></template-empty>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Products from './Products'
import KanomProducts from './KanomProducts'
import mainPayment from './mainPayment.vue'
import EcommerceOrderSummary from './ecommerce-order-summary'
import TemplateEmpty from '@/components/view/template/template-empty'
import Wholesale from './Wholesale'
import AstonAds from './AstonAds'
import AstonTagSummary from './AstonTagSummary'
import BearhouseOrder from './BearhouseOrder'
import BearhouseOrder2 from './BearhouseOrder2'
import ProductAnalytics from './ProductAnalytics.vue'
import AstonAuction from './AstonAuction.vue'
import CartSummary from './CartSummary.vue'
import Promotion from './Promotion.vue'
import ShippingMethod from './ShippingMethod.vue'
import SalePage from './SalePage.vue'
import Delivery from './Delivery.vue'
import Shippop from './Shippop.vue'
import Influencers from '@/components/view/influencer/Influencers.vue'
import Orderdaily from './Orderdaily.vue'
import ShopProfilePage from './ShopProfilePage'
import LalamoveOrderList from './LalamoveOrderList'
import ProductsTab from './ProductsTab.vue'

export default {
  data: function() {
    return {
      currentView: null,
      showAllMenu: true,
      menuTab: [
        {
          name: this.$t('Shop Profile'),
          tab: 'ShopProfilePage',
          image: 'icon_Shop Profile',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('product_discount'),
          tab: 'Products',
          image: 'icon_product_coupon',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Payments'),
          tab: 'mainPayment',
          image: 'icon_Payments',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Shipping Method'),
          tab: 'ShippingMethod',
          image: 'icon_Shipping',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Sale Page'),
          tab: 'SalePage',
          image: 'icon_Salepage',
          isPremiumLock: ['premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Cart Summary'),
          tab: 'CartSummary',
          image: 'icon_Cart Summary',
          isPremiumLock: ['premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Order Summary'),
          tab: 'ecommerce-order-summary',
          image: 'icon_Order Summary',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        },
        {
          name: this.$t('Google Map'),
          tab: 'Delivery',
          image: 'icon_Google Map',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: this.$store.state.foodDelivery
        },
        {
          name: this.$t('Influencers'),
          tab: 'Influencers',
          image: 'icon_Influencers',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: ['103876431747147', '176922345693076']
        },
        {
          name: this.$t('ยอดการสั้งซื้อตามวัน'),
          tab: 'orderdaily',
          image: 'icon_Pre-order Summary',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: ['100164365566364', '145969602635827']
        }
      ]
    }
  },
  components: {
    ShopProfilePage,
    TemplateEmpty,
    KanomProducts,
    EcommerceOrderSummary,
    mainPayment,
    Wholesale,
    AstonAds,
    AstonTagSummary,
    BearhouseOrder,
    BearhouseOrder2,
    ProductAnalytics,
    AstonAuction,
    CartSummary,
    Promotion,
    ShippingMethod,
    Delivery,
    Shippop,
    Influencers,
    SalePage,
    Orderdaily,
    LalamoveOrderList,
    ProductsTab
    // Products
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      // switch (vm.$route.query.tab) {
      //   case 'products':
      //   case 'ecommerce-category':
      //   case 'ecommerce-order-summary':
      //   case 'bearhouse-order':
      //   case 'wholesale':
      //   case 'aston-auction':
      //   case 'product-analytic':
      //   case 'cart-summary':
      //   case 'payment':
      //   case 'promotion':
      //     vm.currentView = vm.$route.query.tab
      //     break
      //   default:
      //     vm.currentView = 'products'
      //     break
      // }
      vm.showAllMenu = false
      vm.currentView = vm.$route.query.tab
    } else {
      // vm.currentView = 'Products'
    }
  },
  mounted() {
    if (
      this.$store.state.centralPage.includes(this.selectedBot.pageid) &&
      this.$store.state.privilege.role === 'admin' &&
      this.$store.state.loginChannel === 'account'
    ) {
      this.menuTab = [
        {
          name: this.$t('Order Summary'),
          tab: 'ecommerce-order-summary',
          image: 'icon_Order Summary',
          isPremiumLock: ['normal', 'premium', 'advanced'],
          page: []
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      allPage: 'allPage',
      isFacebook: 'isFacebook',
      getBotPageRole: 'getBotPageRole'
    }),

    isSelectedBot: function() {
      return this.$store.state.isSelectedBot
    },

    showProductAnalytic() {
      return (
        this.getBotPageRole ||
        [
          '467836640405246',
          '108271771804858',
          '119372009466481',
          'Ue6d636f361ec3b591a5a214fece9a6e2'
        ].includes(this.selectedBot.pageid) ||
        (['361231620965547', '853384435005817'].includes(this.selectedBot.pageid) &&
          !this.isFacebook)
      )
    }
  },
  methods: {
    setShowAllMenu() {
      if (this.$route.query.tab) {
        this.$router.push(this.$route.path).catch(() => {})
      }
      this.currentView = null
      this.showAllMenu = true
    },
    setTabMenu(name) {
      this.currentView = name
      this.showAllMenu = false
    },
    updateRoute: function() {
      try {
        this.$router
          .push({
            name: 'template',
            path: '/template',
            query: {
              tab: this.currentView
            }
          })
          .catch(() => {})
      } catch (error) {}
      this.routeValue = JSON.stringify(this.$route.query)
      // if(this.currentView=='Wholesale'||this.currentView=='Promotion'){
      //   this.currentView='Products'
      // }
    }
  },
  watch: {
    currentView: function() {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce.vue